import clsx from 'clsx';
import styles from './MagazineTag.module.scss';
import type { MagazineTagProps } from './types';

const MagazineTag = ({
  title,
  variant = 'default',
  size = 'medium',
  asButton,
  isHighlighted = false,
  className,
  ...props
}: MagazineTagProps) => {
  const Tag = asButton ? 'button' : 'div';

  return (
    <Tag
      {...(props as any)}
      className={clsx(
        styles.base,
        styles[variant],
        styles[size],
        {
          [styles.highlighted]: isHighlighted,
        },
        className
      )}
    >
      {title}
    </Tag>
  );
};

export default MagazineTag;
